<template>
  <TopHeader class="landing-container-top" />
  <div ref="scrollElement" class="page-chat-ppt wh-full overflow-auto relative">
    <!-- 首屏 -->
    <SectionBanner :handler="() => handleTrail('/editor/page/chat', '_blank')" />

    <!-- 赋能全行业 -->
    <SectionIndustry :handler="() => handleTrail('/editor/page/chat', '_blank')" />

    <!-- 两步打造 -->
    <TowStep :handler="handleTrail" />

    <!-- 不止观看 -->
    <InteractiveUnderstand :handler="() => handleTrail('/editor/page/chat', '_blank')" />

    <!-- 创作到互动 -->
    <CreateInteractive :handler="handleTrail" />

    <!-- 1000家见证 -->
    <EnterpriseCases />

    <!-- FAQs -->
    <SectionFaq />
    <!-- footer -->
    <StartRightNow :handler="handleTrail" />

    <Footer />
  </div>
</template>

<script lang="ts" setup>
import Footer from '~/design/widgets/bottom-footer/footer-cn.vue';
import StartRightNow from '~/design/widgets/start-right-now/index.vue';
import TopHeader from '~/design/widgets/top-header/index.vue';
import CreateInteractive from './components/create-interactive.vue';
import EnterpriseCases from './components/enterprise-cases.vue';
import InteractiveUnderstand from './components/interactive-understand.vue';
import SectionBanner from './components/section-banner.vue';
import SectionFaq from './components/section-faq.vue';
import SectionIndustry from './components/section-industry.vue';
import TowStep from './components/tow-step.vue';

const handleTrail = (url = '/editor/page/chat', target = '_self') => {
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    location.href = `${location.origin}${url}`;
    return;
  }
  window.open(`${location.origin}${url}`, target);
};
</script>
